<template>
  <!--nav>
    <router-link to="/projectAbout">项目介绍</router-link>|
    <router-link to="/plaintiff">我是原告</router-link>｜
    <router-link to="/defendant">我是被告</router-link>|
    <router-link to="/litigationProcess">涉诉流程</router-link>|
    <router-link to="/riskSelfAssessment">风险自评</router-link>|
    <router-link to="/policyAdministration">保单管理</router-link>|
    <router-link to="/policyShopping">保险商城</router-link>｜
    <router-link to="/binding">我要入驻</router-link>｜
    <router-link to="/userOrder">服务订单</router-link>|
    <router-link to="/">关于我们</router-link> |
  </nav-->
  <div id="app"  v-wechat-title="$route.meta.title">
    <router-view/>
  </div>
</template>
<style lang="less" scoped>
* {
  margin:0;
  padding:0;
 }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #F1F1F1;
  height: 100%;
}
</style>
